import { render } from "./GiftcardsBanner.vue?vue&type=template&id=701fd4d1&scoped=true"
import script from "./GiftcardsBanner.vue?vue&type=script&lang=js"
export * from "./GiftcardsBanner.vue?vue&type=script&lang=js"

import "./GiftcardsBanner.vue?vue&type=style&index=0&id=701fd4d1&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701fd4d1"]])

export default __exports__